import { KitContainedIcon, KitLink, KitText } from '@omni/kit/components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import Colors from '../theming/Colors';
import Spacing from '../theming/Spacing';
import { LoginButtons } from './LoginButtons';
import { AuthProvider } from './index';

const NoAccountFoundScreen = ({
  phoneNumber,
  appKey,
  customReturnUrl,
  loginEnabledProviders,
  openInNewTab,
  source,
  targetProvider,
  reset,
}: {
  phoneNumber: string;
  appKey: string;
  customReturnUrl?: string;
  loginEnabledProviders: AuthProvider[];
  openInNewTab?: boolean;
  source?: string;
  targetProvider?: AuthProvider;
  reset: () => void;
}): JSX.Element => {
  // ------------------------------------------------------------
  // Context & Custom Hooks

  const { t } = useTranslation();
  const insets = useSafeAreaInsets();

  return (
    <>
      <View style={styles.container}>
        <View style={styles.iconContainer}>
          <KitContainedIcon name='user' size='md' />
        </View>
        <View>
          <KitText center h1 style={styles.title} color={Colors.N900}>
            {t('auth:noAccountTitle', {
              number: phoneNumber,
            })}
          </KitText>
          <KitText center style={styles.subtitle} color={Colors.N900}>
            {t('auth:noAccountSubtitle')}
          </KitText>
        </View>
        <LoginButtons
          appKey={appKey}
          customReturnUrl={customReturnUrl}
          loginEnabledProviders={loginEnabledProviders || []}
          openInNewTab={openInNewTab}
          source={source}
          targetProvider={targetProvider}
        />
      </View>
      <KitLink
        fontSize={16}
        onPress={reset}
        color={Colors.N900}
        style={[styles.link, { marginBottom: insets.bottom + Spacing.xl }]}
      >
        {t('auth:backToLogin')}
      </KitLink>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: Spacing.xl,
    maxWidth: 600,
  },
  iconContainer: {
    marginBottom: Spacing.l,
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    marginBottom: Spacing.s,
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: Spacing.xl,
  },
  link: {
    textAlign: 'center',
    marginTop: Spacing.xl,
  },
});

export default NoAccountFoundScreen;
